/*
  Boton flotante «Ver ofertas» y medicion de la PDP.
  Lo carga snippets/acf-ir-a-ofertas.liquid con defer. Sin dependencias, ES5.

  - Boton: IntersectionObserver sobre el selector de packs ([data-acf-kb]), con
    comprobacion de respaldo en cada frame de scroll. Se ve cuando el selector se ha
    ido por arriba; se esconde cuando vuelve a verse.
  - Medicion: Shopify.analytics.publish('pdp_…', datos). El pixel personalizado
    de Eventos de clientes los manda a GA4. Ver la cabecera del snippet.
    Los eventos esperan en cola hasta que hay permiso de analisis (banner de
    cookies), asi pdp_vista no se pierde si el visitante acepta despues de cargar.
    Solo mide en el tema publicado; en una vista previa, con ?pdp_medir=1.
  - Botones en linea «Ver la oferta» (sections/acf-cta-oferta.liquid): cualquier
    elemento con data-acf-goto-ofertas (y los enlaces a #acf-ofertas o #acf-buy, como el
    boton de la garantia) baja al selector con el mismo calculo que el
    flotante (cabecera fija y movimiento reducido) y publica pdp_click_cta_oferta.
    Sin este JS, su href (#acf-ofertas) hace el mismo salto con el ancla nativa.
*/
(function () {
  'use strict';
  var W = window;

  /* Si el script vuelve a ejecutarse (editor de temas), solo se inicia el nodo nuevo. */
  if (W.__acfIoInit) { W.__acfIoInit(); return; }
  W.__acfIoInit = init;
  document.addEventListener('shopify:section:load', function () { init(); });
  init();

  function init() {
    /* Se marca el nodo, no la ventana: un boton repintado en el editor se vuelve a enganchar. */
    var cfg = document.querySelector('[data-acf-io]:not([data-acf-io-ok])');
    if (!cfg) return;
    cfg.setAttribute('data-acf-io-ok', '');

    var root = document.querySelector(cfg.getAttribute('data-root')) || document;
    /* Selector de packs propio (bloque packs_kb); si no esta, las filas de precios (tier_rows). */
    var packs = root.querySelector('[data-acf-kb]') || root.querySelector('[data-tiers]');
    var btn = cfg.querySelector('[data-acf-io-btn]');
    var hasBtn = !!(btn && packs);
    var hasIO = 'IntersectionObserver' in W;
    var design = !!(W.Shopify && W.Shopify.designMode);
    /* Las visitas de revision a un tema de vista previa no cuentan, salvo con ?pdp_medir=1. */
    var theme = W.Shopify && W.Shopify.theme;
    var live = !(theme && theme.role && theme.role !== 'main') || /[?&]pdp_medir=1/.test(W.location.search);
    /* Una sola medicion por pagina aunque haya mas de un nodo. */
    var measure = cfg.getAttribute('data-measure') === '1' && !design && live && !W.__acfIoMeasuring;
    if (measure) W.__acfIoMeasuring = 1;
    var tpl = cfg.getAttribute('data-tpl') || '';
    var handle = cfg.getAttribute('data-handle') || '';

    /* ---------- publicar ---------- */
    var queue = [];
    var waiting = false;
    var giveUp = false;   /* sin API de privacidad a los 5 s: decide el permiso del pixel */
    var denied = false;
    var granted = false;  /* el visitante acaba de aceptar en el banner */

    function consentOk() {
      if (granted) return true;
      var cp = W.Shopify && W.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return giveUp;
      return !!cp.analyticsProcessingAllowed();
    }
    function flush() {
      var a = W.Shopify && W.Shopify.analytics;
      if (!a || typeof a.publish !== 'function' || !consentOk()) return false;
      while (queue.length) {
        var q = queue.shift();
        try { a.publish(q[0], q[1]); } catch (e) {}
      }
      return true;
    }
    function publish(name, extra) {
      if (!measure || denied) return;
      var data = { plantilla: tpl, producto: handle };
      if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) data[k] = extra[k];
      queue.push([name, data]);
      if (!flush() && !waiting) {
        waiting = true;
        W.addEventListener('load', flush);
        setTimeout(function () { giveUp = true; flush(); }, 5000);
      }
    }
    if (measure) {
      document.addEventListener('visitorConsentCollected', function (e) {
        if (e.detail && e.detail.analyticsAllowed) { denied = false; granted = true; flush(); }
        else { denied = true; granted = false; queue.length = 0; }
      });
    }

    /* % del documento que ya ha pasado por la pantalla */
    function depth() {
      var d = document.documentElement;
      var b = document.body;
      var h = Math.max(d.scrollHeight, b ? b.scrollHeight : 0);
      if (!h) return 0;
      var seen = (W.pageYOffset || d.scrollTop || 0) + W.innerHeight;
      return seen >= h - 4 ? 100 : Math.floor(seen / h * 100);
    }

    /* ---------- boton ---------- */
    var on = false;
    var lastLift = 0;

    /* Si hay algo fijo abajo en el centro (boton flotante de Releasit, volver arriba
       centrado), el nuestro se pone encima en vez de taparlo. */
    function lift() {
      var vh = W.innerHeight;
      var l = 0;
      var others = [
        document.getElementById('floatingBuyNowButton'),
        document.querySelector('.scroll-to-top-btn-bottom-center')
      ];
      for (var i = 0; i < others.length; i++) {
        var el = others[i];
        if (!el) continue;
        var r = el.getBoundingClientRect();
        var cs = W.getComputedStyle(el);
        if (!r.height || cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) continue;
        if (r.top > vh / 2 && r.top < vh) l = Math.max(l, Math.round(vh - r.top));
      }
      if (l !== lastLift) {
        lastLift = l;
        btn.style.setProperty('--acf-io-lift', l + 'px');
      }
    }

    function show(v) {
      if (v === on) return;
      on = v;
      if (v) lift();
      if (v) btn.classList.add('is-on'); else btn.classList.remove('is-on');
    }

    /* Visible solo si el selector mide algo y ya ha salido entero por arriba. */
    function syncBtn() {
      var r = packs.getBoundingClientRect();
      show(r.height > 0 && r.bottom <= 0);
    }

    function goToPacks(ev, target) {
      var dest = target || packs;
      if (!target) publish('pdp_click_ver_ofertas', { profundidad: depth() });
      /* La cabecera fija reaparece al subir: se deja su altura de margen. */
      var off = 12;
      var hdr = document.querySelector('.section-header');
      if (hdr) {
        var pos = W.getComputedStyle(hdr).position;
        if (pos === 'sticky' || pos === 'fixed') off += hdr.getBoundingClientRect().height;
      }
      var y = Math.max(0, Math.round(dest.getBoundingClientRect().top + (W.pageYOffset || 0) - off));
      var reduce = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (reduce) {
        /* base.css pone scroll-behavior: smooth en html; con movimiento reducido, salto directo. */
        var html = document.documentElement;
        var prev = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        W.scrollTo(0, y);
        html.style.scrollBehavior = prev;
      } else {
        try { W.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { W.scrollTo(0, y); }
      }
      /* Con teclado (detail 0), el foco va al pack elegido. Con el dedo no se toca el foco. */
      if (ev && ev.detail === 0) {
        var t = dest.querySelector('input:checked') || dest.querySelector('input, button, [tabindex]');
        if (t) { try { t.focus({ preventScroll: true }); } catch (e2) {} }
      }
    }

    if (hasBtn) {
      if (hasIO) {
        new IntersectionObserver(function (entries) {
          var e = entries[entries.length - 1];
          show(!e.isIntersecting && e.boundingClientRect.height > 0 && e.boundingClientRect.bottom <= 0);
        }).observe(packs);
      }
      btn.addEventListener('click', function (ev) { goToPacks(ev); });
    }

    /* Botones en linea (acf-cta-oferta). Un solo listener por pagina; el selector se
       busca en cada clic porque el editor puede repintar la seccion. */
    if (!W.__acfIoGoto) {
      W.__acfIoGoto = 1;
      document.addEventListener('click', function (ev) {
        var a = ev.target && ev.target.closest ? ev.target.closest('[data-acf-goto-ofertas], a[href="#acf-ofertas"], a[href="#acf-buy"]') : null;
        if (!a) return;
        var dest = document.querySelector('[data-acf-kb]') || document.querySelector('[data-tiers]') || document.getElementById('acf-buy');
        if (!dest) return;   /* sin selector en la pagina: que mande el href */
        ev.preventDefault();
        publish('pdp_click_cta_oferta', { profundidad: depth(), boton: a.getAttribute('data-acf-goto-ofertas') || '' });
        goToPacks(ev, dest);
      });
    }

    /* ---------- medicion ---------- */
    var marks = [25, 50, 75, 100];
    var next = measure ? 0 : marks.length;
    var pending = [];   /* secciones aun no alcanzadas, en orden de pagina */

    function checkDepth() {
      if (next >= marks.length) return;
      var p = depth();
      while (next < marks.length && p >= marks[next]) {
        publish('pdp_scroll_' + marks[next], { umbral: marks[next] });
        next++;
      }
    }

    /* Una seccion cuenta como vista cuando su borde de arriba sube por encima del 55 %
       de la pantalla. Se mira en cada frame de scroll y no con un observador porque un
       salto largo (ancla, fling) se salta secciones sin que el observador se entere. */
    function checkSections() {
      if (!pending.length) return;
      var limit = W.innerHeight * 0.55;
      for (var i = 0; i < pending.length; i++) {
        var el = pending[i];
        if (!el.offsetHeight) continue;   /* oculta en este dispositivo */
        if (el.getBoundingClientRect().top < limit) {
          pending.splice(i--, 1);
          publish(el.__acfIoName, { seccion: el.__acfIoKey });
        }
      }
    }

    function check() {
      checkDepth();
      checkSections();
    }

    /* Tras el load, las secciones que miden 0 (ocultas en este dispositivo) salen de la
       lista: si no, el scroll nunca dejaria de trabajar. */
    function checkLoad() {
      check();
      var keep = [];
      for (var i = 0; i < pending.length; i++) if (pending[i].offsetHeight > 0) keep.push(pending[i]);
      pending = keep;
    }

    if (measure) {
      publish('pdp_vista');
      var watch = function (el, key) {
        key = String(key).toLowerCase().replace(/[^a-z0-9_]/g, '_');
        el.__acfIoKey = key;
        el.__acfIoName = ('pdp_seccion_' + key).slice(0, 40);   /* GA4: 40 caracteres */
        pending.push(el);
      };
      var secs = document.querySelectorAll('[id^="shopify-section-template--"]');
      for (var j = 0; j < secs.length; j++) {
        watch(secs[j], secs[j].id.split('__').pop());
        if (j === 0 && packs) watch(packs, 'packs');   /* el selector va dentro de la primera */
      }
      if (!secs.length && packs) watch(packs, 'packs');

      /* La altura final no se conoce hasta el load (imagenes); la primera lectura va ahi. */
      if (document.readyState === 'complete') checkLoad();
      else W.addEventListener('load', checkLoad);
    }

    /* Un solo listener de scroll por boton, pasivo y a ritmo de frame. */
    var ticking = false;
    function tick() {
      ticking = false;
      check();
      if (hasBtn) syncBtn();
      if (on) lift();
    }
    function onScroll() {
      /* Boton repintado en el editor: el viejo ya no esta en la pagina. */
      if (btn && btn.isConnected === false) { W.removeEventListener('scroll', onScroll); return; }
      if (ticking) return;
      if (next >= marks.length && !pending.length && !hasBtn) return;
      ticking = true;
      W.requestAnimationFrame(tick);
    }
    if (measure || hasBtn) W.addEventListener('scroll', onScroll, { passive: true });
  }
})();
